// Photos from a phone are 3–10 MB and 4000+ px wide; the model reads text well at ~2000 px,
// and the server takes at most 15 MB. Re-encoding as JPEG also turns a HEIC photo into
// something the server can read, on browsers that can decode HEIC (Safari).
const MAX_IMAGE_EDGE = 2000;

const shrinkImage = file =>
  new Promise(resolve => {
    const isImage = file.type.startsWith("image/") || /\.hei[cf]$/i.test(file.name);
    if (!isImage) return resolve(file);
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => {
      URL.revokeObjectURL(url);
      const scale = Math.min(1, MAX_IMAGE_EDGE / Math.max(img.width, img.height));
      const heic = /hei[cf]/i.test(file.type) || /\.hei[cf]$/i.test(file.name);
      if (scale === 1 && file.size < 3 * 1024 * 1024 && !heic) return resolve(file);
      const canvas = document.createElement("canvas");
      canvas.width = Math.round(img.width * scale);
      canvas.height = Math.round(img.height * scale);
      const ctx = canvas.getContext("2d");
      ctx.fillStyle = "#fff";
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
      canvas.toBlob(
        blob =>
          resolve(
            blob
              ? new File([blob], file.name.replace(/\.[^.]+$/, "") + ".jpg", { type: "image/jpeg" })
              : file
          ),
        "image/jpeg",
        0.85
      );
    };
    img.onerror = () => {
      URL.revokeObjectURL(url);
      resolve(file);
    };
    img.src = url;
  });

export default shrinkImage;
